import { IConfig } from 'configs/config.interface'

export const CONFIG: IConfig = {
	Type: 'preprod',
	API: {
		ContainerTracking:
			'https://afcazewrmlns011finops.azurewebsites.net/containertracking/api',
		Customs: 'https://afcazewrmlns011finops.azurewebsites.net/customs/api',
		DeliveryPlanning:
			'https://afcazewrmlns011finops.azurewebsites.net/deliveryplanning/api',
		Apigee: 'https://api-stage.maersk.com/scm/v1/finops',
		Uaminfo: 'https://api-preprod.scm.maersk.com/finance',
		ViewPdf: 'https://api-stage.maersk.com',
		FrontDoor: 'https://api-preprod.scm.maersk.com/finance',
		ApiCode: '69jjuo4KDjYipb5hdAKUZvfBOCp7aVe5lFR3LUyjnzfRAzFuAvbPMw==',
		ApiKey: 'kPsS3UktOH3l2A5+/YlIUiP1zE7DPlkPfxXf3bDDx/w=',
		FeatureManagementURL: 'https://api-preprod.scm.maersk.com/feature-management/functions/FINOPS/features',
	},
	FunctionCode: 'APIFUNC',
	graphScope: 'https://graph.microsoft.com/User.Read',
	isDataDOGEnabled: 'true',
	dataDogENV: 'ewr',
	dataDogApplicationId: 'd4077f26-0c5f-42ef-b51a-855bf175a037',
	dataDogClientToken: '',
	consumerKey: 'GgnNlO1zCUfJTMWzScfbrQnti9jkatZy',
	walkMe: 'https://cdn.walkme.com/users/5be6ef69cb6d4406a12e152f40b267d3/test/walkme_5be6ef69cb6d4406a12e152f40b267d3_https.js',
	MSAL: {
		instance: 'https://login.microsoftonline.com',
		tenant: 'maersk.onmicrosoft.com',
		signInPolicy: '',
		applicationId: '22eb3953-7e1a-4c33-ac02-86047493f8de',
		cacheLocation: 'sessionStorage',
		scopes: ['https://maersk.onmicrosoft.com/finops-api-preprod/user_impersonation'],
		redirectUri: 'https://finops-preprod.cs.scm.maersk.com/',
		postLogoutRedirectUri: 'https://finops-preprod.cs.scm.maersk.com/',
		storeAuthStateInCookie: true,
	},
	MOP_APP_NAME: 'Damco-Finops-Ui-Preprod',
    MOP_API_KEY: 'O1AcKLvYjO+BsCeLl6shiNKYxAbQDCQdLGhyobC4GE6h/YrDhWZ8ZveMAPdYlg==',
}
